/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddCustomerSpecificReferenceableSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AddCustomerSpecificReferenceableSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const addCustomerSpecificReferenceableSyncEntity = (request:AddCustomerSpecificReferenceableSyncEntityRequest, options?: CashRequestOptions) => post<AddCustomerSpecificReferenceableSyncEntityRequest, AddCustomerSpecificReferenceableSyncEntityResponse>("/2.0/cash/add-customer-specific-referenceable-sync-entity", request, {...options, rejectOnError: true })